"use client";

import { memo } from "react";
import { twMerge } from "tailwind-merge";

import { GenderFilterPart } from "@/components/selectArtistModal/royaltyFreeTab/filterControl/GenderFilterPart";
import { GenreFilterPart } from "@/components/selectArtistModal/royaltyFreeTab/filterControl/GenreFilterPart";
import { PitchRangeCategoryFilterPart } from "@/components/selectArtistModal/royaltyFreeTab/filterControl/PitchRangeCategoryFilterPart";
import { SortArtists } from "@/components/selectArtistModal/royaltyFreeTab/filterControl/SortArtists";

function UnmemoizedFilterControl({
  namespace,
  className,
}: {
  namespace: string;
  className: string;
}) {
  return (
    <div className={twMerge("flex flex-col gap-y-4", className)}>
      <div className="mb-4 flex flex-col gap-x-8 gap-y-4 md:flex-row">
        <GenderFilterPart namespace={namespace} />
        <PitchRangeCategoryFilterPart namespace={namespace} />
        {/* The filter row is a column until md (trigger at the left edge, list must open rightward) and a row from md (trigger pushed to the right end by md:ml-auto, list must open leftward to stay on screen). */}
        <SortArtists
          namespace={namespace}
          listClassName="left-0 origin-top-left md:left-auto md:right-0 md:origin-top-right"
          className="md:ml-auto"
        />
      </div>
      <GenreFilterPart namespace={namespace} />
    </div>
  );
}

export const FilterControl = memo(UnmemoizedFilterControl);
